import throttle from 'lodash/throttle'
import * as Sentry from '@sentry/vue'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'
import { scrollToActiveSlide } from '@/utils/dom.utils'
import { WHEEL_THROTTLE_TIME } from '@/constant/fixedTime'
import EventBus from '@/eventBus'
import constants from '@/constant'
import utils from '@/util'
import UnleashService from '@/services/unleash'

const WHEEL_MIN_DELTA_Y = 7 // Set a standard minimum deltaY value to ignore small movements

const trackWheelScrollUp = (rootState) => {
  const eventAction = 'Select slide by mouse wheel'
  const trackData = {
    eventAction,
    eventCategory: constants.eventCategories.PRESENTATION_EDITOR,
    eventLabel: 'Wheel up',
    presentationId: rootState.presentation.id,
    userId: rootState.currentUser.id,
  }
  utils.trackGA4AndMixpanel(eventAction, trackData)
}

const trackWheelScrollDown = (rootState) => {
  const eventAction = 'Select slide by mouse wheel'
  const trackData = {
    eventAction,
    eventCategory: constants.eventCategories.PRESENTATION_EDITOR,
    eventLabel: 'Wheel down',
    presentationId: rootState.presentation.id,
    userId: rootState.currentUser.id,
  }
  utils.trackGA4AndMixpanel(eventAction, trackData)
}

const handleScrollUp = (rootState, rootGetters) => {
  EventBus.$emit('SideLeft: deselectAllSlides')

  const previousSlide = rootGetters.getPreviousSlide({ slideOrder: rootState.slideActive?.order })
  if (!previousSlide) return

  EventBus.$emit('makeSlideActive', previousSlide, previousSlide?.deleted)
  scrollToActiveSlide()
  trackWheelScrollUp(rootState)
}

const handleScrollDown = (rootState, rootGetters) => {
  EventBus.$emit('SideLeft: deselectAllSlides')

  const nextSlide = rootGetters.getNextSlide({ slideOrder: rootState.slideActive?.order })
  if (!nextSlide) return

  EventBus.$emit('makeSlideActive', nextSlide, nextSlide?.deleted)
  scrollToActiveSlide()
  trackWheelScrollDown(rootState)
}

const _state = {

}

const _getters = {

}

const mutations = {

}

const actions = {
  async initWheelScrollAction({ rootGetters, dispatch }, element) {
    try {
      if (!element || !UnleashService) return

      UnleashService.start()
      await UnleashService.ready
      if (isFeatureEnabled(rootGetters, 'release-wheel-to-scroll-through-slide-list')) {
        dispatch('handleOnMouseWheelEventAction', element)
      }
    } catch (error) {
      Sentry.captureException(error)
    }
  },

  handleOnMouseWheelEventAction({ rootState, rootGetters }, element) {
    if (!element) return
    if (rootGetters.isPresenting || rootGetters.isSharingView || rootGetters.isBackstage) return

    // Throttle function to limit the frequency of the scroll handling
    element.addEventListener('wheel', (event) => {
      // Capture the flag immediately so it isn't lost by throttle
      const skipCustomScroll = event.__skipCustomScroll

      throttle(() => {
        if (skipCustomScroll) return
        if (Math.abs(event.deltaY) < WHEEL_MIN_DELTA_Y) return

        if (event.deltaY < 0) {
          handleScrollUp(rootState, rootGetters)
        } else if (event.deltaY > 0) {
          handleScrollDown(rootState, rootGetters)
        }
      }, WHEEL_THROTTLE_TIME)()
    })
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
